import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { useAuth0 } from "@auth0/auth0-react";
import { mainRoutes } from './config/routes.config';
import { ProtectedRoute } from './components/ProtectedRoute';

function App() {
  const { isLoading } = useAuth0();

  if (isLoading) {
    return <div>Loading...</div>;
  }

  return (
    <Router>
      <Routes>
        {mainRoutes.map((route) => (
          <Route
            key={route.path}
            path={route.path}
            element={<ProtectedRoute element={route.element} />} 
          >
            {route.children?.map((child) => (
              <Route
                key={child.path}
                index={child.index}
                path={child.path}
                element={<child.element />} 
              />
            ))}
          </Route>
        ))}
        <Route path="/" element={<Navigate to="/dashboard" replace />} />
      </Routes>
    </Router>
  );
}

export default App;